import React, { useState, useEffect } from 'react';
import http from "../lib/http";

export default function AddDealerPage() {

  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    password: '',
    address: '',
    category: '',
    gstNo: '',
    pan: '',
    aadhar: '',
    locationName: '',
    image: null
  });

  const [categories, setCategories] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    http.get('/api/categories')
      .then(res => setCategories(res.data))
      .catch(err => console.error(err));
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      setFormData(prev => ({
        ...prev,
        [name]: file
      }));

      setPreview(URL.createObjectURL(file));

    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage('');
    setError('');

    try {

      const data = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== '') {
          data.append(key, value);
        }
      });

      const res = await http.post('/api/dealers/register', data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      setMessage(res.data.message || 'Dealer added successfully');

      setFormData({
        name: '',
        contact: '',
        password: '',
        address: '',
        category: '',
        gstNo: '',
        pan: '',
        aadhar: '',
        locationName: '',
        image: null
      });

      setPreview('');

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Failed to register dealer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">

      <div className="card shadow border-0 mx-auto" style={{ maxWidth: "1000px" }}>
        <div className="card-body p-4">

          <h3 className="fw-bold mb-4 text-center">
            Add New Dealer
          </h3>

          {message && (
            <div className="alert alert-success">
              {message}
            </div>
          )}

          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>

            <div className="row g-4">

              <div className="col-md-6">
                <label className="form-label fw-semibold">Dealer Name</label>

                <input
                  type="text"
                  name="name"
                  className="form-control"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Contact Number</label>

                <input
                  type="text"
                  name="contact"
                  className="form-control"
                  required
                  value={formData.contact}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Password</label>

                <input
                  type="password"
                  name="password"
                  className="form-control"
                  required
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Category</label>

                <select
                  name="category"
                  className="form-select"
                  required
                  value={formData.category}
                  onChange={handleChange}
                >
                  <option value="">Select Category</option>

                  {categories.map((cat) => (
                    <option key={cat._id} value={cat.name}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12">
                <label className="form-label fw-semibold">Address</label>

                <textarea
                  name="address"
                  className="form-control"
                  rows="3"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Location Name</label>

                <input
                  type="text"
                  name="locationName"
                  className="form-control"
                  value={formData.locationName}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">GST No</label>

                <input
                  type="text"
                  name="gstNo"
                  className="form-control"
                  value={formData.gstNo}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">PAN</label>

                <input
                  type="text"
                  name="pan"
                  className="form-control"
                  value={formData.pan}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">Aadhar</label>

                <input
                  type="text"
                  name="aadhar"
                  className="form-control"
                  value={formData.aadhar}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Dealer Image</label>

                <input
                  type="file"
                  name="image"
                  className="form-control"
                  accept="image/*"
                  onChange={handleChange}
                />
              </div>

              {preview && (
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Preview
                  </label>

                  <div>
                    <img
                      src={preview}
                      alt="preview"
                      className="img-thumbnail"
                      style={{
                        width: "150px",
                        height: "120px",
                        objectFit: "cover"
                      }}
                    />
                  </div>
                </div>
              )}

            </div>

            <div className="mt-4 text-end">

              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Add Dealer'}
              </button>

            </div>

          </form>

        </div>
      </div>

    </div>
  );
}